export const CHAPTERS = [
  { id: 'warum', n: '01', label: 'Warum' },
  { id: 'zonen', n: '02', label: 'Zonen' },
  { id: 'schleife', n: '03', label: 'Schleife' },
  { id: 'pakete', n: '04', label: 'Pakete' },
  { id: 'kampagnen', n: '05', label: 'Kampagnen' },
  { id: 'extras', n: '06', label: 'Extras' },
  { id: 'vergleich', n: '07', label: 'Vergleich' },
  { id: 'ablauf', n: '08', label: 'Ablauf' },
  { id: 'auftrag', n: '09', label: 'Auftrag' },
];

export const WHY_STATS = [
  {
    value: '70\u202F%',
    title: 'Entscheidung im Markt',
    text: 'Sieben von zehn Kaufentscheidungen fallen erst im Markt. Wer dort sichtbar ist, ist in dem Moment sichtbar, in dem entschieden wird.',
    source: 'GfK Store Effect',
  },
  {
    value: '8\u202F%',
    title: 'Mehr Abverkauf',
    text: 'Beworbene Produkte werden häufiger gekauft. Feldstudie zu Bildschirmwerbung im Lebensmittelhandel mit 237 Kampagnen und rund 30 Millionen Einkäufen. Genauso funktioniert es für Dienstleistungen externer Partner – von der Rohrreinigung über die Kfz-Werkstatt bis zur Steuerberatung: Die Aufmerksamkeit entsteht im Markt, der Auftrag kommt danach.',
    source: 'Herhausen, de Jong & Grewal, Journal of Marketing 2026',
  },
  {
    value: '3–6 Min.',
    title: 'Volle Aufmerksamkeit',
    text: 'So lange dauert im Schnitt der Weg durch die Kassenzone. Ihr Spot läuft in dieser Zeit mehrfach – ohne Streuverlust, ohne Wegzappen.',
    source: '',
  },
];

export const REACH_STATS = [
  { value: '1,8 Mio.', label: 'Einkäufe pro Jahr an unseren Kassen' },
  { value: '34.600', label: 'Einkäufe pro Woche, im Schnitt' },
  { value: '48.000', label: 'Menschen pro Woche – viele zu zweit oder mit Familie' },
  { value: '2,0 Mio.', label: 'Sichtkontakte pro Monat über alle 50 Bildschirme' },
];

export const ZONES = [
  {
    id: 'kassenzone',
    name: 'Kassenzone',
    short: 'Kassen',
    dwell: '3–6 Min. Aufenthalt',
    screens: 16,
    desc: 'Die wertvollste Zone: Alle kommen hier vorbei und warten. Ihr Spot läuft in dieser Zeit mehrfach.',
    fit: 'Für alle, die maximale Wiederholung wollen.',
  },
  {
    id: 'leergut',
    name: 'Leergut',
    short: 'Leergut',
    dwell: '1–2 Min. Aufenthalt',
    screens: 4,
    desc: 'Wartezeit am Automaten, der Blick sucht Ablenkung. Hier funktionieren längere Botschaften und Erklärungen.',
    fit: 'Für erklärungsbedürftige Angebote.',
  },
  {
    id: 'bedientheken',
    name: 'Bedientheken',
    short: 'Theken',
    dwell: '1–3 Min. Aufenthalt',
    screens: 10,
    desc: 'Beratung, Genuss, Wartenummer. Ideal für Produkte mit Geschmack – und für regionale Erzeuger.',
    fit: 'Für Winzer, Brauereien, Feinkost.',
  },
  {
    id: 'mall',
    name: 'Mall und Vorkasse',
    short: 'Mall',
    dwell: 'kurz, Passage',
    screens: 12,
    desc: 'Die Ladenstraße mit Gastronomie und Dienstleistern – der Ort für Partner aus der Nachbarschaft.',
    fit: 'Für Gastronomie, Handwerk, Dienstleister.',
  },
  {
    id: 'eingang',
    name: 'Eingang und Frische',
    short: 'Eingang',
    dwell: 'kurz, Passage',
    screens: 8,
    desc: 'Der erste Eindruck beim Betreten – Obst, Gemüse, Regionales. Hier beginnt der Einkauf.',
    fit: 'Für Marken und regionale Produkte.',
  },
];

export const EXTRAS_TABLE = [
  { name: 'Spotproduktion Standard', what: 'Animierter Spot aus Ihren Bildern, Logo und Text, 10 Sekunden, inkl. 2 Korrekturen', price: '490 €', unit: 'einmalig' },
  { name: 'Spotproduktion Plus', what: 'Motion-Design mit Bildwelt und Sprecher-Text als Einblendung, 15 Sekunden', price: '990 €', unit: 'einmalig' },
  { name: 'Spotproduktion Film', what: 'Dreh bei Ihnen vor Ort, Schnitt und drei Fassungen für Saison oder Aktionen', price: '1.500 €', unit: 'einmalig' },
  { name: 'Branchenexklusivität', what: 'Kein Wettbewerber aus Ihrer Branche während Ihrer Laufzeit (im Premium enthalten)', price: '+ 30 %', unit: 'auf den Paketpreis' },
  { name: 'Zeitfenster', what: 'Ausstrahlung nur in Ihren Zeiten, z. B. Feierabend oder Wochenende (im Premium enthalten)', price: '+ 15 %', unit: 'auf den Paketpreis' },
  { name: 'Sponsoring Rezept der Woche', what: 'Ihr Name und Logo bei unserem beliebtesten Format – auf allen Bildschirmen', price: '990 €', unit: 'pro Monat' },
];

export const COMPARISON_ROWS = [
  { channel: 'Bildschirme in der Markthalle', price: '5 bis 6 €', waste: 'sehr gering', proximity: 'im Markt, am Regal', highlight: true },
  { channel: 'Radio regional', price: '2 bis 3 €', waste: 'hoch', proximity: 'gering' },
  { channel: 'Tageszeitung', price: 'rund 10 €', waste: 'hoch', proximity: 'gering' },
  { channel: 'Plakat und City-Light', price: 'je nach Standort', waste: 'mittel', proximity: 'unterwegs' },
  { channel: 'Social Media, lokal ausgesteuert', price: 'niedrig', waste: 'mittel', proximity: 'am Handy, nicht im Markt' },
];

export const PROCESS_STEPS = [
  {
    n: '1',
    title: 'Paket wählen und Auftrag senden',
    text: 'Sie wählen Paket, Laufzeit und Extras, tragen Ihre Daten ein und unterschreiben digital. Wir bestätigen den Auftrag innerhalb von zwei Werktagen.',
    time: 'heute',
  },
  {
    n: '2',
    title: 'Spot anliefern oder produzieren lassen',
    text: 'Sie schicken uns Ihren fertigen Spot (16:9, 10 oder 15 Sekunden, ohne Ton) – oder wir produzieren ihn aus Ihren Bildern und Texten.',
    time: 'bis 10 Werktage vor Start',
  },
  {
    n: '3',
    title: 'Auf Sendung',
    text: 'Ab dem vereinbarten Starttermin läuft Ihr Spot in der Schleife – bis zu 260-mal am Tag auf jedem gebuchten Bildschirm. Änderungen übernehmen wir kurzfristig.',
    time: 'ab Starttermin',
  },
];

export const TERMS = [
  'Vertragspartner und Vertragsschluss. Vertragspartner ist die GLOBUS Markthalle Koblenz (Betreiber siehe Impressum). Mit dem Absenden dieses Auftrags gibt der Kunde ein verbindliches Angebot ab. Der Vertrag kommt mit der Auftragsbestätigung des Marktes in Textform zustande, die in der Regel innerhalb von zwei Werktagen erfolgt.',
  'Leistung. Der Markt strahlt den Spot des Kunden in den gebuchten Zonen und Schleifenplätzen während der Öffnungszeiten aus. Angaben zu Sichtkontakten sind Modellwerte auf Basis der Einkäufe an der Kasse und keine zugesicherte Eigenschaft.',
  'Laufzeit und Kündigung. Monatspakete laufen über die gewählte Mindestlaufzeit und verlängern sich danach um jeweils einen Monat, wenn sie nicht mit einer Frist von vier Wochen zum Monatsende in Textform gekündigt werden. Kampagnen enden mit Ablauf der gebuchten Dauer.',
  'Preise und Zahlung. Alle Preise verstehen sich netto zuzüglich der gesetzlichen Umsatzsteuer. Monatspakete werden monatlich im Voraus berechnet, einmalige Leistungen mit der ersten Rechnung, Kampagnen mit der Auftragsbestätigung. Rechnungen sind innerhalb von 14 Tagen ohne Abzug zahlbar.',
  'Spot und Freigabe. Der Kunde liefert den Spot spätestens zehn Werktage vor dem Starttermin (MP4, 1920 × 1080, 10 oder 15 Sekunden, ohne Ton) oder beauftragt die Produktion. Der Markt prüft jeden Spot und kann Inhalte ablehnen, die gegen Gesetze (insbesondere UWG, HWG, Jugendschutz), gegen berechtigte Interessen des Marktes oder gegen Sortimentsvorgaben verstoßen. Ausgeschlossen sind Werbung für Tabak, Glücksspiel, verschreibungspflichtige Arzneimittel sowie politische und religiöse Werbung.',
  'Rechte und Freistellung. Der Kunde versichert, alle für die Ausstrahlung nötigen Rechte an Bildern, Marken, Texten und abgebildeten Personen zu besitzen, und stellt den Markt von Ansprüchen Dritter frei.',
  'Exklusivität. Branchenexklusivität gilt nur, wenn sie gebucht oder im Paket enthalten ist, und bezieht sich auf die im Auftrag angegebene Branche. Eigene Inhalte und Angebote des Marktes bleiben davon unberührt.',
  'Störungen. Fallen in einem Monat mehr als zehn Prozent der gebuchten Ausstrahlungen aus technischen Gründen aus, erhält der Kunde nach seiner Wahl Ersatzausstrahlungen oder eine anteilige Gutschrift. Für höhere Gewalt haftet der Markt nicht.',
  'Stornierung. Bis 14 Tage vor dem Starttermin kann der Auftrag kostenfrei storniert werden. Danach werden bei Monatspaketen 50 Prozent des ersten Monats, bei Kampagnen 50 Prozent des Kampagnenpreises fällig. Bereits erbrachte Produktionsleistungen werden in voller Höhe berechnet.',
  'Datenschutz. Die Daten des Kunden werden ausschließlich zur Abwicklung des Vertrags verarbeitet und nicht an Dritte weitergegeben.',
  'Schlussbestimmungen. Änderungen bedürfen der Textform. Es gilt deutsches Recht. Gerichtsstand ist Koblenz, soweit der Kunde Kaufmann ist. Sollte eine Bestimmung unwirksam sein, bleibt der Vertrag im Übrigen wirksam.',
];
